import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d1c3db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "country-selector custom-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "countrySearch",
  class: "form-label"
}, "Search Country", -1))
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "country-dropdown"
}
const _hoisted_5 = ["onMousedown"]
const _hoisted_6 = { class: "country-flag" }
const _hoisted_7 = { class: "country-name" }
const _hoisted_8 = {
  key: 0,
  class: "no-results"
}

import { ref, computed, watch } from 'vue';
import { countries, type Country } from './CountriesList';
import countryFlagEmoji from 'country-flag-emoji';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelector',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchQuery = ref('');
const showDropdown = ref(false);
const selectedCountry = ref<Country | null>(
  props.modelValue ? countries.find(c => c.name === props.modelValue) || null : null
);

// Update searchQuery when selectedCountry changes
watch(selectedCountry, (newValue) => {
  if (newValue) {
    searchQuery.value = newValue.name;
  }
});

// Initialize searchQuery with selectedCountry if it exists
if (selectedCountry.value) {
  searchQuery.value = selectedCountry.value.name;
}

const filteredCountries = computed(() => {
  if (!searchQuery.value) return countries;
  const query = searchQuery.value.toLowerCase();
  return countries.filter(country => 
    country.name.toLowerCase().includes(query) || 
    country.code.toLowerCase().includes(query)
  );
});

function getCountryFlag(code: string) {
  const flag = countryFlagEmoji.get(code);
  return flag ? flag.emoji : '';
}

function selectCountry(country: Country) {
  selectedCountry.value = country;
  searchQuery.value = country.name;
  emit('update:modelValue', country.name);
  showDropdown.value = false;
}

function handleBlur() {
  setTimeout(() => {
    showDropdown.value = false;
    // Reset searchQuery to selected country if user didn't select anything
    if (selectedCountry.value) {
      searchQuery.value = selectedCountry.value.name;
    } else if (searchQuery.value) {
      // Try to find a country that matches the search query
      const matchedCountry = countries.find(
        c => c.name.toLowerCase() === searchQuery.value.toLowerCase()
      );
      if (matchedCountry) {
        selectCountry(matchedCountry);
      } else {
        searchQuery.value = '';
      }
    }
  }, 200);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-control",
      id: "countrySearch",
      placeholder: selectedCountry.value ? selectedCountry.value.name : 'Search for a country',
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = true)),
      onBlur: handleBlur
    }, null, 40, _hoisted_3), [
      [_vModelText, searchQuery.value]
    ]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCountries.value, (country) => {
            return (_openBlock(), _createElementBlock("div", {
              key: country.code,
              class: "country-option",
              onMousedown: ($event: any) => (selectCountry(country))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(getCountryFlag(country.code)), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(country.name), 1)
            ], 40, _hoisted_5))
          }), 128)),
          (filteredCountries.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No countries found "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})